module.exports = __webpack_public_path__ + "img/标题icon_2.7799e192.png";